@if (loading) {
  <div class="loader"></div>
}
<div class="side-bar" (mouseleave)="showMenu(false); hideAllSubMenus()"
  [ngClass]="{'opened': menuIsOpen, 'red-bg': menuColor == 'red', 'blue-bg' : menuColor == 'blue'}">
  <div class="head" (mouseenter)="showMenu(true); $event.stopPropagation();">
    <div class="menu-icon" [ngClass]="{'opened': menuIsOpen}" (click)="toggleMenu()"></div>
  </div>
  <div class="menu-buttons-container" (mouseenter)="showMenu(true); $event.stopPropagation()">
    @for (page of activeMenu; track trackByName($index, page)) {
      @if ((page.secure_module == 0 || _gS.validateAcces({id:page.secure_module, type:'read'}, page)) && !page.isBackButton) {
        <a class="menubutton"
          (Click)="onClickLink()" [routerLink]="page.link">
          @if (!menuIsOpen) {
            <div class="abb short">{{page.name | translate | abbreviation}}</div>
          }
          @if (menuIsOpen) {
            <div class="abb" (mouseenter)="toggleShowSubMenu(page.name, true)">{{page.name | translate}}</div>
          }
        </a>
      }
      @if (page.isBackButton) {
        <div class="menubutton go-back" (click)="onClickLink(page.link)">
          <div class="abb">&lt;</div>
          <!-- <div class="tittle no-break">{{'Go back' | translate}}</div> -->
        </div>
      }
      @if (page.subMenu && showSubMenu(page.name)) {
        <ul class="secondary-menu">
          @for (subPage of page.subMenu; track subPage) {
            <div>
              @if (subPage.secure_module == 0 || _gS.validateAcces({id:subPage.secure_module, type:'read'})) {
                <li class="secondary-menu-item" (click)="onClickLink(subPage.link)" [routerLink]="subPage.link" >
                  {{subPage.name | translate}}
                </li>
              }
            </div>
          }
        </ul>
      }
    }
  </div>
</div>
<div class="user">
  <div class="image">
    {{getUser()}}
    <!-- <img src="../../../assets/img/profile.jpeg" (load)="imageLoad($event)" alt=""> -->
  </div>
  <div class="arrow"></div>
  <ul class="menuoptions">
    <li>
      {{getUserLong()}}
    </li>
    <li class="click" (click)="logout()">
      {{'Logout' | translate}}
    </li>
  </ul>
</div>

<!-- <div class="filesToUpload" *ngIf="_gS.uploadFiles.length < _gS.filesToUpload.length" (click)="uplodFiles()">
{{_gS.uploadFiles.length}} / {{_gS.filesToUpload.length}}
<span *ngIf="!upladingImage">{{'Images' | translate}}</span>
<span *ngIf="upladingImage">{{'Uploading' | translate}}</span>
</div> -->

<worker-window></worker-window>
